export default class Validators {
  
  static get IDENTIFICATION_REGEX() {
    return {
      NIF_REGEX: /^(\d{8})([A-Z])$/,      
      CIF_REGEX: /^(ES)?([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/,
      NIE_REGEX: /^[XYZ]\d{7,8}[A-Z]$/
    }
  }

  static documentIdentification = (identificator) => {

    if (!identificator) return { type: "", isValid: false }
    
    // Ensure upcase and remove whitespace
    identificator = identificator.toUpperCase().replace(/\s/, '')

    let isValid = false
    let type = Validators.getIdentificationType(identificator)

    switch (type) {
      case "NIF":
        isValid = Validators.isValidNif(identificator)
        break
      case "CIF":
        isValid = Validators.isValidCif(identificator)
        break
      case "NIE":
        isValid = Validators.isValidNie(identificator)
        break
      default:
        break
    }
    return { type: type, isValid: isValid }
  }

  static getIdentificationType = (identificator) => {
    
    if (identificator.match(Validators.IDENTIFICATION_REGEX.NIF_REGEX)) return "NIF"
    if (identificator.match(Validators.IDENTIFICATION_REGEX.CIF_REGEX)) return "CIF"
    if (identificator.match(Validators.IDENTIFICATION_REGEX.NIE_REGEX)) return "NIE"
    return null
  }

  // Returns if a nif is valid
  static isValidNif = (dni) => {
    let dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE"
    let letter = dni_letters.charAt(parseInt(dni, 10) % 23)
    
    return letter === dni.charAt(8)
  }

  /* Returns if a cif is valid
    1. Verify that the first letter is uppercase. 
    2. Calculate the sum of the digits, doubling the digits in even positions and adjusting if the result is greater than 9. 
    3. Calculate the control digit and compare it with the control digit provided in the CIF.*/  
  static isValidCif(cif) {
    if (!cif) {
      return false;
    }
    if (cif.toUpperCase().startsWith("ES")) {
      cif =  cif.substring(2);
    }    
    if (!cif || cif.length !== 9) {
      return false;
    }

    let letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    let digits = cif.substr(1, cif.length - 2);
    let letter = cif.substr(0, 1);
    let control = cif.substr(cif.length - 1);
    let sum = 0;
    let i;
    let digit;

    if (!letter.match(/[A-Z]/)) {
      return false;
    }

    for (i = 0; i < digits.length; ++i) {
      digit = parseInt(digits[i],10);

      if (isNaN(digit)) {
        return false;
      }

      if (i % 2 === 0) {
        digit *= 2;
        if (digit > 9) {
          digit = parseInt(digit / 10,10) + (digit % 10);
        }

        sum += digit;
      } else {
        sum += digit;
      }
    }

    sum %= 10;
    if (sum !== 0) {
      digit = 10 - sum;
    } else {
      digit = sum;
    }

    if (letter.match(/[ABEH]/)) {
      return String(digit) === control;
    }
    if (letter.match(/[NPQRSW]/)) {
      return letters[digit] === control;
    }

    return String(digit) === control || letters[digit] === control;
  }

  // Returns if a nie is valid
  static isValidNie = (nie) => {
    // Change the initial letter for the corresponding number and validate as DNI
    var nie_prefix = nie.charAt(0)

    switch (nie_prefix) {
      case 'X':
        nie_prefix = 0
        break
      case 'Y':
        nie_prefix = 1
        break
      case 'Z':
        nie_prefix = 2
        break
      default:
        break
    }

    return Validators.isValidNif(nie_prefix + nie.substr(1))
  }
}


// WEBPACK FOOTER //
// ./src/components/Utilities/Validators.js